import { AnyMerchant } from 'APIs/merchants/merchants.types';
import { PaymentPlanLimitAPIResponse } from 'Components/ManageMerchant/Components/MerchantDetails/types';
import { Currency } from 'utils/currency';

type payPlanLimitType = {
  maxPayPlanAmountConfirmedCustomers: number;
  maxPayPlanAmountUnconfirmedCustomers: number;
  minPlanLimit: number;
  currency: Currency;
};

export interface MerchantAPIResponseType {
  brandName: string;
  businessName: string;
  merchantId: string;
  payplanLimit: payPlanLimitType;
  website: string;
  stripeAccountId: null | string;
  slug: string;
}

type ToMerchantAPIResponseType = (
  AnyMerchant: AnyMerchant,
  payPlanLimits: PaymentPlanLimitAPIResponse,
) => MerchantAPIResponseType;

export const toMerchantAPIResponseType: ToMerchantAPIResponseType = (
  merchant: AnyMerchant,
  payPlanLimits: PaymentPlanLimitAPIResponse,
) => ({
  brandName: merchant.businessProfile.brandName,
  businessName: merchant.businessProfile.businessName,
  merchantId: merchant.merchantId,
  payplanLimit: payPlanLimits,
  website: merchant.businessProfile.website || '',
  stripeAccountId: null,
  slug: merchant.readableIdentifier,
});
